// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [data2, setData2] = useState([]);
  const token = authServices.getToken();

  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.name, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.name);


  const [formData, setFormData] = useState({

    id: null,
    portType: '',
    // unitId: null,
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************

  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/port_type/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });
        if (response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || null,
            portType: response.data.data.portType || '',
            // unitId: response.data.data.unitId || null,
          });
        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };



  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/port_type/update`, formData, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  useEffect(() => {
    fetchUnit();
    fetchInvoiceData();
  }, [invoiceId, edit]);


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Port_Type
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>
                 
                  {/* <div className="spacing">
                    <label htmlFor="unitId" className="label-custom">Unit </label>
                    <Autocomplete
                      // className={` ${errors.Unit ? 'input-error' : ''}`}
                      disablePortal
                      options={validData2} // Full user object
                      getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                      getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                      renderInput={(params) => <TextField {...params} label={formData.unit} />}
                      onChange={(event, value) => {
                        if (value) {
                          setFormData({ ...formData, Unit: value.id }); // Save 'id' in state
                        } else {
                          setFormData({ ...formData, Unit: "" }); // Reset state 
                        }
                      }}
                      // Key attribute setup using 'id'
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          {option.name}
                        </li>
                      )}
                      // Scroll enable kare inline style ke sath
                      componentsProps={{
                        paper: {
                          style: {
                            maxHeight: '120px', // Dropdown ki maximum height
                            overflowY: 'auto',  // Scroll enable karega
                          },
                        },
                      }}
                    />
                  </div> */}

                  <div className="spacing">
                    <label htmlFor="portType" className="label-custom">Port Type</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="portType"
                      name="portType"
                      value={formData.portType}
                      onChange={handleChange}
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
